import {
	_t,
	formatPhoneNumber,
	barkApi,
	bugsnagClientNotify,
	ViewportSize,
} from '@bark/bark-core';
import { cfbLogTrackingEvent, callFeedbackModalTracking } from './call_feedback';
import { displayCallReminderModal } from '../call-reminder/call_reminder';

export default function (activityLog = null) {
	const { Handlebars } = window;
	const viewportSize = ViewportSize();


	const state = {
		projectResponseId: '',
		buyerName: '',
		buyerNumber: '',
		projectCreated: '',
		categoryName: '',

		buyer_id: '',
		project_id: '',
		booking_id: '',
		seller_profile_id: '',
		seller_call_feedback_sms: false,
	};

	const resetState = () => {
		Object.keys(state).forEach((key) => (state[key] = ''));
	};

	const setInState = (data) => {
		for (const key in data) {
			if (state.hasOwnProperty(key)) {
				state[key] = data[key];
			}
		}
	};

	const getFromState = (key) => {
		return state.hasOwnProperty(key) ? state[key] : '';
	};

	const domElements = {
		modalId: 'call-feedback-modal',
		modalContainerId: 'call-feedback-modal-container',
	};

	const hbTemplates = {
		modalTemplate: Handlebars.compile(
			document.getElementById('call-feedback-modal-template').innerHTML,
		),
	};

	const show = (isSellerUpdate = false) => {
		if (!state.buyerNumber) {
			return;
		}

		buildModal(isSellerUpdate);
		resetCopyToClipboard();
		bindListeners();

		cfbLogTrackingEvent('call_feedback - modal-view', state);

		$(`#${domElements.modalId}`).modal('show');
	};

	const buildModal = (isSellerUpdate = false) => {
		$(`#${domElements.modalContainerId}`).empty();
		let { phoneNumberToDisplay, phoneNumberToDial } = formatPhoneNumber(
			state.buyerNumber,
		);
		let html = hbTemplates.modalTemplate({
			buyerName: state.buyerName,
			buyerNumber: phoneNumberToDisplay,
			buyerNumberToDial: phoneNumberToDial,
			isSellerUpdate: isSellerUpdate,
			text: {
				callBuyer: isSellerUpdate
					? _t('seller_common:call-feedback-modal-update.call-buyer', {
							buyer_public_name: state.buyerName,
					  })
					: _t('seller_common:call-feedback-modal.call-buyer', {
							buyer_public_name: state.buyerName,
					  }),
				copyToClipboard: _t('seller_common:call-feedback-modal.copy-to-clipboard-text'),
				copied: _t('seller_common:call-feedback-modal.copied-label'),
				updateProgressTitle: isSellerUpdate
					? ''
					: _t('seller_common:call-feedback-modal.update-progress-title'),
				noAnswerButton: _t('seller_common:call-feedback-modal.no-answer-button', {
					new_line: '<br/>',
					interpolation: { escapeValue: false },
				}),
				leftVoicemailButton: _t(
					'seller_common:call-feedback-modal.left-voicemail-button',
					{
						new_line: '<br/>',
						interpolation: { escapeValue: false },
					},
				),
				weTalkedButton: _t('seller_common:call-feedback-modal.we-talked-button', {
					new_line: '<br/>',
					interpolation: { escapeValue: false },
				}),
			},
		});
		$(`#${domElements.modalContainerId}`).append(html);
	};

	const bindListeners = () => {
		const tracking = callFeedbackModalTracking({
			buyer_id: state.buyer_id,
			project_id: state.project_id,
			seller_profile_id: state.seller_profile_id,
			booking_id: state.booking_id,
			seller_call_feedback_sms: state.seller_call_feedback_sms,
		});

		$('.js-modal-cross-dimiss')
			.off('click')
			.on('click', function (e) {
				e.preventDefault();
				tracking('Cancel - Select');
				$(`#${domElements.modalId}`).modal('hide');
			});

		$('.js-cfb-dismiss-btn')
			.off('click')
			.on('click', function (e) {
				e.preventDefault();
				tracking('Feedback - Select', { feedback_option: 'did-not-call' });
				$(`#${domElements.modalId}`).modal('hide');
			});

		$('.js-cfb-no-answer-btn')
			.off('click')
			.on('click', function (e) {
				e.preventDefault();
				updateResponseContact('no-answer');
				tracking('Feedback - Select', { feedback_option: 'no-answer' });
				$(`#${domElements.modalId}`).modal('hide');
			});

		$('.js-cfb-left-voicemail-btn')
			.off('click')
			.on('click', function (e) {
				e.preventDefault();
				updateResponseContact('left-voicemail');
				tracking('Feedback - Select', { feedback_option: 'left-voicemail' });
				$(`#${domElements.modalId}`).modal('hide');
			});

		$('.js-cfb-we-talked-btn')
			.off('click')
			.on('click', function (e) {
				e.preventDefault();
				updateResponseContact('we-talked');
				tracking('Feedback - Select', { feedback_option: 'we-talked' });
				$(`#${domElements.modalId}`).modal('hide');
			});

		$(`#${domElements.modalId} .copy-link`)
			.off('click')
			.on('click', function (e) {
				e.preventDefault();
				navigator.clipboard.writeText(state.buyerNumber);
				cfbLogTrackingEvent('call_feedback - modal-copy-number-button-clicked', state);
				$(`#${domElements.modalId} .copy-link-container`).addClass('success');
				setTimeout(function () {
					resetCopyToClipboard();
				}, 3000);
			});
	};

	const resetCopyToClipboard = () => {
		$(`#${domElements.modalId} .copy-link-container`).removeClass('success');
	};

	const bindShowNumberLinkListener = () => {
		$('.buyer-telephone-show-link')
			.off('click')
			.on('click', function (e) {
				e.preventDefault();
				show();
				cfbLogTrackingEvent('call_feedback - show-number-link-clicked', state);
			});
		$('.buyer-telephone-display a').on('click', function (e) {
			show();
		});
		
		$('.buyer-email-display a').on('click', function (e) {
			cfbLogTrackingEvent('buyer-email-click', state);
		});
	};

	const updateResponseContact = (feedbackValue) => {
		barkApi(
			'response/contact/',
			{
				response_id: state.projectResponseId,
				type: 'phone',
				enabled: 1,
				data: { feedback: feedbackValue },
			},
			(res) => {
				if (Bark.sellerResponseFlow) {
					Bark.sellerResponseFlow.completeTask('call');
				}
				displayCallReminderModal(activityLog, res.response_action_id);

				if (activityLog) {
					setTimeout(() => {
						activityLog.redraw();
					}, 1000);
				}
			},
			(error) => {
				bugsnagClientNotify('Failed to update response contact', error);
			},
			'POST',
			{
				Accept: 'application/vnd.bark.v2+json',
			},
		);
	};

	return {
		show,
		setInState,
		getFromState,
		resetState,
		bindShowNumberLinkListener,
	};
}
